module.exports = __webpack_public_path__ + "static/index/img/wechat.89bc2f8d.png";